module.exports = "/assets/iphone.png?jMEjohC";